import {
  ValidatedInput,
  ValidationMessage,
  Sidebar,
  FormLabel
} from "@/app/shared/components";
import employeeService from "../employeeService.js"
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    companyId: {
      type: Number,
      default: null
    },
    companies: {
      type: Array,
      required: true
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar,
    FormLabel,
    'v-select': vSelect
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 1) {
        this.$emit("onNewData");
      } 
      else {
        this.$emit("onEditData");
      }
    }
  },
  data() {
    return {
      model: {
        id : 0,
        firstName: "N/A", // initial value to avoid validation error when control is not shown
        lastName: "N/A",  // idem
        referenceName: "",
        employeeNumber: "",
        companyId: this.companyId,
        isActive: true
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    employees() {
      return this.$store.state.drilling.employees;
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      this.model = this.data;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.model = {
        id: 0,
        firstName : "",
        lastName : "",
        referenceName : "",
        companyId : this.companyId,
        employeeNumber : "",
        isActive : true
      }
    },
    submitData() {
      const _this = this;
      this.$refs.observer.validate().then((result) => {
        if (result) {
          if (_this.model.id !== null && _this.model.id > 0) {
            employeeService.editEmployee(_this.model)
              .then((response) => {
                _this.$emit("onUpdated", response.data.model);
              })
              .finally(() => {
                _this.$vs.loading.close();
              });
          } else {
            employeeService.addEmployee(_this.model)
              .then((response) => {
                _this.$emit("onInserted", response.data.model);
                _this.model.id = response.data.model.id;
              })
              .finally(() => {
                _this.$vs.loading.close();
              });
          }
        }
      });
    }
  }
};
